import styled, { css } from 'styled-components';

export const HeroContainer = styled.section(
  ({ theme }) => css`
    max-width: none;
    background:
      radial-gradient(120% 80% at 30% 5%, rgba(255, 187, 0, 0.12) 0%, rgba(255, 187, 0, 0) 55%),
      radial-gradient(80% 60% at 100% 100%, rgba(110, 61, 191, 0.1) 0%, rgba(0, 0, 0, 0) 60%),
      linear-gradient(180deg, #1c2535 0%, #20293a 50%, #232c3d 100%);
    color: ${theme.co.neutral99};
    padding: ${theme.sz.s24} ${theme.sz.s20} ${theme.sz.s16};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    overflow: hidden;

    &::after {
      content: '';
      position: absolute;
      width: 480px;
      height: 480px;
      border-radius: 50%;
      background: radial-gradient(circle, rgba(255, 187, 0, 0.18) 0%, rgba(255, 187, 0, 0) 70%);
      top: -120px;
      left: 30%;
      pointer-events: none;
    }

    @media (max-width: ${theme.sz.lg}) {
      padding: ${theme.sz.s7} ${theme.sz.s6} ${theme.sz.s8};
      text-align: center;
    }
  `,
);

export const LogoWrapper = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s4};
    margin-bottom: ${theme.sz.s14};
    font-size: 6rem;
    color: #ffc001;

    @media (max-width: ${theme.sz.lg}) {
      display: none;
    }
  `,
);

export const BackButton = styled.button(
  () => css`
    background: none;
    border: none;
    color: #fff;
    font-size: 1.5rem;
    cursor: pointer;
    padding: 0;
    line-height: 1;
  `,
);

export const MobileEyebrow = styled.div(
  ({ theme }) => css`
    display: none;

    @media (max-width: ${theme.sz.lg}) {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 14px;
      color: ${theme.co.primary20};
      font-size: 0.875rem;
      font-weight: 700;
      letter-spacing: 0.12em;
      margin-bottom: ${theme.sz.s4};

      &::before,
      &::after {
        content: '';
        width: 28px;
        height: 2px;
        background: ${theme.co.primary20};
        border-radius: 2px;
      }
    }
  `,
);

export const MobileTitle = styled.h1(
  ({ theme }) => css`
    display: none;

    @media (max-width: ${theme.sz.lg}) {
      display: block;
      font-weight: 800;
      font-size: 2.5rem;
      line-height: 1.15;
      color: #fff;
      letter-spacing: -0.01em;
      margin: 0 0 ${theme.sz.s4};
      text-align: center;

      em {
        font-style: normal;
        color: ${theme.co.primary20};
      }
    }
  `,
);

export const DesktopTitle = styled.h1(
  ({ theme }) => css`
    font-family: ${theme.DEPRECATED_ty.openSans};
    font-weight: 700;
    font-size: 3.25rem;
    line-height: 1.18;
    color: #fff;
    letter-spacing: -0.01em;
    margin: 0 0 ${theme.sz.s7};
    max-width: 560px;

    strong {
      font-weight: 800;
    }

    @media (max-width: ${theme.sz.lg}) {
      display: none;
    }
  `,
);

export const SubLine = styled.p(
  ({ theme }) => css`
    font-weight: 500;
    font-size: 1.25rem;
    line-height: 1.5;
    color: #d8dde6;
    margin: 0 0 ${theme.sz.s10};

    strong {
      color: #fff;
      font-weight: 700;
    }

    @media (max-width: ${theme.sz.lg}) {
      font-size: 1rem;
      margin: 0 0 ${theme.sz.s5};
    }
  `,
);

export const Divider = styled.div(
  ({ theme }) => css`
    height: 1px;
    background: rgba(255, 255, 255, 0.14);
    margin: ${theme.sz.s1} 0 ${theme.sz.s7};
    max-width: 560px;

    @media (max-width: ${theme.sz.lg}) {
      margin: ${theme.sz.s5} 0;
      max-width: none;
    }
  `,
);

export const BulletList = styled.ul(
  ({ theme }) => css`
    list-style: none;
    padding: 0;
    margin: 0 0 ${theme.sz.s8};
    display: flex;
    flex-direction: column;
    gap: 14px;

    @media (max-width: ${theme.sz.lg}) {
      display: none;
    }
  `,
);

export const BulletItem = styled.li(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: 14px;
    font-size: 1.125rem;
    color: #eaecf1;
    font-weight: 500;

    &::before {
      content: '';
      width: 9px;
      height: 9px;
      border-radius: 50%;
      background: ${theme.co.primary20};
      flex-shrink: 0;
    }
  `,
);

export const MobileSubText = styled.p(
  ({ theme }) => css`
    display: none;

    @media (max-width: ${theme.sz.lg}) {
      display: block;
      font-size: 0.9375rem;
      color: #cdd2dc;
      line-height: 1.45;
      margin: 0;
      font-weight: 500;

      strong {
        color: #fff;
        font-weight: 700;
      }
    }
  `,
);

export const QuoteBlock = styled.div(
  ({ theme }) => css`
    max-width: 560px;

    @media (max-width: ${theme.sz.lg}) {
      display: none;
    }
  `,
);

export const Stars = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: 4px;
    margin-bottom: 14px;
    color: ${theme.co.primary20};

    svg {
      width: 28px;
      height: 28px;
    }
  `,
);

export const QuoteText = styled.p(
  () => css`
    font-size: 1.0625rem;
    line-height: 1.55;
    color: #e6e9ef;
    font-weight: 500;
    margin: 0 0 10px;
  `,
);

export const QuoteAuthor = styled.div(
  () => css`
    font-size: 0.875rem;
    color: #8e94a0;
    font-weight: 500;
  `,
);
